import { Field, Form, Formik } from "formik";
import { useCallback, useEffect, useState } from "react";
import { Form as BForm, Card, Col, Container, Nav, Row, Tab } from "react-bootstrap";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import * as Yup from "yup";
import crose from "../../../../assets/images/icons/crose.svg";
import TextInput from "../../../../components/formfields/InputField";
import AddTaskForm from "../../../accountComplete/components/todo";
import { getHomeDataAction } from "../../../home/actions";
import { addHomeDataAction, uploadFileAction, uploadFileNewAction } from "./actions";
import "./style.scss";
import HeroSection from "./HeroSection";
import SocialSection from "./SocialSection";
import GlobalFeaturesSection from "./GlobalFeaturesSection";
import ToolboxSection from "./ToolboxSection";
import ResourceSection from "./ResourceSection";
import CareerSection from "./CareerSection";
import TestimonialSection from "./TestimonialSection";
import FreebiesSection from "./FreebiesSection";

// removed unused imports
const generalSchema = Yup.object({
  name: Yup.string().required("Name can not be empty"),
  excerpt: Yup.string().required("Excerpt can not be empty"),
});

const EditHome = (props) => {
  const [generalEdit, setGeneralEdit] = useState(false);
  const [images, setImages] = useState("");
  const history = useHistory();
  const [keywords, setKeywords] = useState([]);
  const addKeywords = (text) => setKeywords([...keywords, text]);
  const removeExpertise = (index) => {
    const newTasks = [...keywords];
    newTasks.splice(index, 1);
    setKeywords(newTasks);
  };
  const generalState = {
    name: props.home_data?.name ? props.home_data?.name : "",
    url: props.home_data?.url ? props.home_data?.url : "/",
    excerpt: props.home_data?.excerpt ? props.home_data?.excerpt : "",
    thumbnail: props.home_data?.thumbnail ? props.home_data?.thumbnail : "",
  };

  const handleGeneralSubmit = (values) => {
    setGeneralEdit(false);
    const form_data = new FormData();
    form_data.append("name", values.name);
    form_data.append("excerpt", values.excerpt);
    form_data.append("keywords", keywords);
    form_data.append("thumbnail", values.thumbnail);
    props.addHomeDataAction(form_data, setGeneralEdit, "add-general-info");
  };

  useEffect(() => {
    props.getHomeDataAction();
  }, []);
  useEffect(() => {
    setKeywords(props.home_data?.keywords ? props.home_data?.keywords : []);
  }, [props.home_data?.keywords]);

  // const handleUpload = (event, fieldValue, name) => {
  //   const formData = new FormData();
  //   formData.append("file", event.currentTarget.files[0]);
  //   formData.append("folder", "home-page");
  //   formData.append("url", event.currentTarget.files[0]?.name);
  //   props.uploadFileAction(formData, fieldValue, name);
  //   props.uploadFileNewAction(formData, fieldValue, name);
  // };

  const onImageChange = useCallback(
    (event, fieldValue, name) => {
      if (event.target.files?.[0]) {
        const file = event.target.files[0];

        const URL = window.URL || window.webkitURL;
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);
        img.src = objectUrl;
        img.onload = function handleImageLoad() {
          fieldValue(name, event.target.files[0]);
          const reader = new FileReader();
          reader.onload = (e) => {
            setImages(e?.target?.result);
          };
          reader.readAsDataURL(event.target.files[0]);
        };
      }
    },
    [setImages],
  );

  const handleRemove = useCallback((field, fieldValue) => {
    fieldValue(field, "");
    setImages("");
  }, []);

  return (
    <>
      <Container className="homePageAdmin">
        <div className="d-flex flex-wrap align-items-center justify-content-between titleBoxWrap mb-25">
          <h2 className="adminSectionTitle">Home Page</h2>
          <button
            className="btn btn-primary"
            onClick={() => {
              history.push("/admin/pages");
            }}
          >
            <i className="fa-regular fa-arrow-left"></i> Back
          </button>
        </div>
        <Tab.Container id="left-tabs-example" defaultActiveKey="home1">
          <Row>
            <Col md={3}>
              <Nav variant="pills" className="flex-column nav-pills1">
                <Nav.Item>
                  <Nav.Link eventKey="home1">General Info</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="home2">Hero Section</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="home3">Social Section</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="home4">Global Features Section</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="home5">Toolbox Section</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="home6">Resource Section</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="home7">Career Section</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="home8">Testimonial Section</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="home9">Freebies Section</Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col md={9}>
              <Tab.Content className="themeTabs">
                <Tab.Pane eventKey="home1">
                  <Formik enableReinitialize initialValues={generalState} validationSchema={generalSchema} onSubmit={handleGeneralSubmit}>
                    {({ values, handleChange, handleBlur, setFieldValue }) => {
                      return (
                        <Form>
                          <Card>
                            <Card.Header className="d-flex justify-content-between align-items-center">
                              <h6 className={`mb-0 ${generalEdit ? "editTitle" : ""}`}>General Info</h6>
                              {generalEdit ? (
                                <button type="submit" className="btn btn-primary">
                                  <i className="fa-regular fa-floppy-disk"></i> Save
                                </button>
                              ) : (
                                <span className="btn btn-green" onClick={() => setGeneralEdit(true)}>
                                  Edit <i className="fa-regular fa-pen-to-square ms-2"></i>
                                </span>
                              )}
                            </Card.Header>
                            <Card.Body className="position-relative">
                              <div
                                className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${generalEdit ? "d-none" : ""}`}
                                style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                              ></div>
                              <Row className="gy-3">
                                <Col xs={12}>
                                  <BForm.Label className="form-label">Name</BForm.Label>
                                  <Field
                                    name="name"
                                    component={TextInput}
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Name"
                                    readOnly={!generalEdit}
                                    disabled={!generalEdit}
                                    className={generalEdit ? "edit" : ""}
                                  />
                                </Col>
                                <Col xs={12}>
                                  <BForm.Label className="form-label" htmlFor="url">
                                    URL
                                  </BForm.Label>
                                  <BForm.Control name="url" type="text" id="url" value={values.url} placeholder="URL" readOnly disabled />
                                </Col>
                                <Col xs={12}>
                                  <BForm.Label className={`form-label ${!generalEdit ? "editLabel" : ""}`}>Excerpt</BForm.Label>
                                  <Field
                                    name="excerpt"
                                    component={TextInput}
                                    value={values.excerpt}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Excerpt"
                                    readOnly={!generalEdit}
                                    className={generalEdit ? "editField" : ""}
                                    multiline
                                    disabled={!generalEdit}
                                  />
                                </Col>
                                <Col className={`${generalEdit ? "editField" : ""}`}>
                                  <label className="form-label">Keywords</label>
                                  {generalEdit ? <AddTaskForm addTask={addKeywords} placeholder="Keywords" /> : ""}
                                  <ul className="todo-list mt-0 gap-2 mt-3">
                                    {keywords?.map((task, index) => (
                                      <li key={task} className="todo m-0">
                                        <span className="label">{task}</span>
                                        {generalEdit ? (
                                          <span className="delete" onClick={() => removeExpertise(index)}>
                                            <img src={crose} alt="delete" />
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                      </li>
                                    ))}
                                  </ul>
                                </Col>
                                <Col xs={12}>
                                  <label className={`form-label ${!generalEdit ? "edit" : ""}`} htmlFor="image">
                                    Thumbnail
                                  </label>
                                  <div className="uploarForm position-relative overflow-hidden">
                                    {images || values.thumbnail ? (
                                      <>
                                        <img className="img-fluid" src={images || values.thumbnail} alt="imagesss" />
                                        {generalEdit ? (
                                          <button
                                            className="btn btn-danger btn-sm btn-icon position-absolute top-0 end-0 rounded me-2 mt-2"
                                            onClick={() => handleRemove("thumbnail", setFieldValue)}
                                          >
                                            <i className="fa-regular fa-trash-can"></i>
                                          </button>
                                        ) : null}
                                      </>
                                    ) : (
                                      <>
                                        <i class="fa-light fa-upload fa-2x text-primary"></i>
                                        <h6 className="mb-0 mt-3">Upload Images</h6>
                                        <input
                                          id="thumbnail"
                                          name="thumbnail"
                                          type="file"
                                          onChange={(e) => {
                                            onImageChange(e, setFieldValue, "thumbnail");
                                          }}
                                        />
                                      </>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </Form>
                      );
                    }}
                  </Formik>
                </Tab.Pane>
                <Tab.Pane eventKey="home2">
                  <HeroSection props={props} />
                </Tab.Pane>
                <Tab.Pane eventKey="home3">
                  <SocialSection props={props} />
                </Tab.Pane>
                <Tab.Pane eventKey="home4">
                  <GlobalFeaturesSection props={props} />
                </Tab.Pane>
                <Tab.Pane eventKey="home5">
                  <ToolboxSection props={props} />
                </Tab.Pane>
                <Tab.Pane eventKey="home6">
                  <ResourceSection />
                </Tab.Pane>
                <Tab.Pane eventKey="home7">
                  <CareerSection props={props} />
                </Tab.Pane>
                <Tab.Pane eventKey="home8">
                  <TestimonialSection props={props} />
                </Tab.Pane>
                <Tab.Pane eventKey="home9">
                  <FreebiesSection props={props} uploadFileNewAction={props.uploadFileNewAction} />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  home_data: state.home.home_data,
});

export default connect(mapStateToProps, {
  addHomeDataAction,
  getHomeDataAction,
  uploadFileAction,
  uploadFileNewAction,
})(withRouter(EditHome));
